import React from 'react';
import { Container } from 'react-bootstrap';
import './Ecosystem.scss';

export default function Ecosystem() {
    return (
        <div className="ecosystem-bg-color" id="Ecosystem">
            <div className="ecosystem-bg-circle">
                <Container>
                    <div className="title-div">
                        <h1 className="ecosystem-title">
                            Built on{' '}
                            <span className="ecosystem-title-colored">Solana Ecosystem</span>
                        </h1>
                    </div>
                    <div className="ecosystem-content">
                        <p className="content-para">
                        Solana is the fastest growing blockchain with key platforms like Serum, Raydium and many DeFi protocols being built on it.
                        SolRazr aims to supercharge the adoption of Solana network by helping developers and projects raise capital and build fast.
                        </p>
                    </div>
                    <div>
                        <div className="ecosystem-image" />
                    </div>
                </Container>
            </div>
        </div>
    );
}
